export default "https://cdn-static.gokick.com/assets/c678e0ba2e275fccd6b7b161f66793b4454cd3c4/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";